var render = function render(_c,_vm){return _c('svg',{staticClass:"fill-current animate-spin h-5 w-5",class:_vm.data.staticClass || ''},[_c('use',{attrs:{"xlink:href":"#icon-spinner"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }